export default {"src":"/_next/static/media/earned.1b8187d3.svg","height":24,"width":98,"blurWidth":0,"blurHeight":0};